<template>
  <div>
    <section class="p-toppage__cassette">
      <div class="p-toppage__cassette__wrap">
        <div
          class="p-toppage__cassette__title sp_tabTitle"
          :class="{ 'is-active': currentId === 0 }"
          @click="onChangeSearch(0)"
        >
          LifeService
        </div>
        <div class="spacer"></div>
        <div
          class="p-toppage__cassette__title sp_tabTitle"
          :class="{ 'is-active': currentId === 1 }"
          @click="onChangeSearch(1)"
        >
          Goods
        </div>
      </div>
    </section>
    <section class="p-toppage__search">
      <div class="p-toppage__search__wrap">
        <div class="p-toppage__search__main">
          <div class="p-toppage__search__main__nav c-card">
            <!-- lifeService item filter start -->
            <template v-if="currentId === 0">
              <div class="c-card__content">
                <!-- lifeService item filter start -->
                <div class="p-toppage__search__main__input c-card__inner">
                  <div class="p-toppage__search__main__row">
                    <div
                      class="p-toppage__search__main__areaSelector"
                      v-if="form.lifeIsActive === 1"
                    >
                      <div class="c-select">
                        <select
                          class="c-select__control"
                          v-model="form.catLrgClassCd"
                          @change="onChangeLargeCat($event)"
                          :disabled="!largeCategoryList"
                        >
                          <option selected value="" class="default">
                            大カテゴリ
                          </option>
                          <option
                            v-for="(large, i) in largeCategoryList"
                            :key="`large-${i}`"
                            :value="large.catClassCd"
                          >
                            {{ large.name }}
                          </option>
                        </select>
                      </div>
                      <div class="c-select">
                        <select
                          class="c-select__control"
                          v-model="form.catMidClassCd"
                          @change="onChangeMidCat($event)"
                          :disabled="
                            form.catLrgClassCd === '' || !middleCategoryList
                          "
                        >
                          <option selected value="" class="default">
                            中カテゴリ
                          </option>
                          <option
                            v-for="(middle, i) in middleCategoryList"
                            :key="`middle-${i}`"
                            :value="middle.catClassCd"
                          >
                            {{ middle.name }}
                          </option>
                        </select>
                      </div>
                      <div class="c-select">
                        <select
                          class="c-select__control"
                          v-model="form.catSmlClassCd"
                          :disabled="
                            form.catMidClassCd === '' || !smallCategoryList
                          "
                        >
                          <option selected value="" class="default">
                            小カテゴリ
                          </option>
                          <option
                            v-for="(small, i) in smallCategoryList"
                            :key="`small-${i}`"
                            :value="small.catClassCd"
                          >
                            {{ small.name }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div
                      class="p-toppage__search__main__areaSelector"
                      v-if="form.lifeIsActive === 2"
                    >
                      <div class="c-select">
                        <select
                          class="c-select__control"
                          v-model="form.areaMidClassCd"
                          @change="onChangeMidArea($event)"
                          :disabled="areaMidClasses.length === 0"
                        >
                          <option selected value="" class="default">
                            大エリア
                          </option>
                          <option
                            v-for="(mid, i) in areaMidClasses"
                            :key="`mid-${i}`"
                            :value="mid.areaMidClassCd"
                          >
                            {{ mid.areaMidClassNm }}
                          </option>
                        </select>
                      </div>
                      <div class="c-select">
                        <select
                          class="c-select__control"
                          v-model="form.areaSmlClassCd"
                          @change="onChangeSmlArea($event)"
                          :disabled="
                            form.areaMidClassCd === '' ||
                              areaSmlClasses.length === 0
                          "
                        >
                          <option selected value="" class="default">
                            中エリア
                          </option>
                          <option
                            v-for="(sml, i) in areaSmlClasses"
                            :key="`sml-${i}`"
                            :value="sml.areaSmlClassCd"
                          >
                            {{ sml.areaSmlClassNm }}
                          </option>
                        </select>
                      </div>
                      <div class="c-select">
                        <select
                          class="c-select__control"
                          v-model="form.areaDtlClassCd"
                          :disabled="
                            form.areaMidClassCd === '' ||
                              areaDtlClasses.length === 0
                          "
                        >
                          <option selected value="" class="default">
                            小エリア
                          </option>
                          <option
                            v-for="(small, i) in areaDtlClasses"
                            :key="`small-${i}`"
                            :value="small.areaDtlClassCd"
                          >
                            {{ small.areaDtlClassNm }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div
                    class="p-toppage__search__main__row"
                    v-if="form.lifeIsActive === 2"
                  >
                    <div class="p-toppage__search__main__genreSelect">
                      <div class="c-select c-select--genre">
                        <select
                          class="c-select__control"
                          @change="lifeGenreChanged"
                          :disabled="!categoryList"
                        >
                          <option selected value="" class="default">
                            ジャンル
                          </option>
                          <option
                            v-for="cat in categoryList"
                            :key="`cat-${cat.name}`"
                            :value="
                              cat.catClassCd + ',' + cat.name + ',' + cat.level
                            "
                          >
                            {{ cat.name }}
                          </option>
                        </select>
                      </div>
                      <div class="p-toppage__search__main__genreTagList">
                        <div
                          v-for="(item, index) in lifeGenreTags"
                          class="p-toppage__search__main__genreTags"
                          v-bind:key="index"
                        >
                          <span>
                            <span>
                              {{ item.name }}
                            </span>
                            <button v-on:click="deleteLifeGenreTags(index)">
                              ×
                            </button>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="p-toppage__search__main__row">
                    <div class="p-toppage__search__main__keyword">
                      <KeywordSearch
                        :placeholder="
                          '施設名、メニューNo、地名などを入力 (例 : 大阪 出張)'
                        "
                        @input="input"
                        @onSearch="onSearch(currentId)"
                        :background="true"
                        :error="form.keywordError != ''"
                      />
                      <div
                        v-if="form.keywordError"
                        class="p-toppage__search__main__input--error"
                      >
                        <span>
                          <IconAlert name="alert" />
                        </span>
                        {{ form.keywordError }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-if="currentId === 1">
              <ShopBeneOnlineShop :boCode="boCode" />
            </template>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import uniqBy from "lodash/uniqBy";
import filter from "lodash/filter";
import KeywordSearch from "@/general/components/pages/KeywordSearch.vue";
import {
  getLargeCategories,
  getCodesArea,
  getLargeCodesArea
} from "@/general/store/api";
import IconAlert from "@/common/components/icons/IconAlert.vue";
import ShopBeneOnlineShop from "@/general/components/shop/BeneOnlineShop.vue";

/** @typedef {import("@/general/store/models").Categories} Categories */

export default {
  components: {
    KeywordSearch,
    IconAlert,
    ShopBeneOnlineShop
  },
  props: {
    boCode: {
      type: String
    },
    currentId: {
      type: Number,
      default: 0
    },
    switchTab: {
      type: Function
    }
  },
  data() {
    return {
      /** @type {{ catClassCd: string; name: string; level: number }[]} */
      lifeGenreTags: [],

      /** @type {Categories[]} */
      categories: [],

      /** @type {{ areaLrgClassCd: string; areaMidClassCd: string; areaMidClassNm: string; }[]} */
      areaMidClasses: [],

      /** @type {{ areaSmlClassCd: string; areaSmlClassNm: string; }[]} */
      areaSmlClasses: [],

      /** @type {{ areaDtlClassCd: string; areaDtlClassNm: string; }[]} */
      areaDtlClasses: [],

      form: {
        lifeIsActive: 1, // 1: LifeService > 暮らす・遊ぶ、2: LifeService > 食べる、3: Goods
        keyword: "",
        keywordError: "",
        areaLrgClassCd: "",
        areaMidClassCd: "",
        areaSmlClassCd: "",
        areaDtlClassCd: "",
        catLrgClassCd: "",
        catMidClassCd: "",
        catSmlClassCd: "",
        pointFrom: "",
        pointTo: "",
        numberError: "",
        chkCurrentPoint: false
      }
    };
  },

  async mounted() {
    this.switchTab(this.currentId);
    this.getMidCodesArea();
    const res = await getLargeCategories();
    if (res) {
      this.categories = res.categories || [];
    }
  },

  computed: {
    /** @returns {Array<Categories>} */
    largeCategoryList() {
      if (this.categories.length) {
        const listFilter = filter(
          this.categories,
          (item) =>
            item.level === 1 &&
            ((+item.catClassCd >= 101 && +item.catClassCd <= 114) ||
              (+item.catClassCd >= 116 && +item.catClassCd <= 119))
        );
        return uniqBy(listFilter, "catClassCd");
      }
      return [];
    },
    /** @returns {Array<Categories>} */
    middleCategoryList() {
      if (this.categories.length) {
        const listFilter = filter(this.categories, (item) => {
          if (
            item.level === 2 &&
            item.catLrgClassCd === this.form.catLrgClassCd
          ) {
            if (
              (item.catLrgClassCd === "011" || item.catLrgClassCd === "113") &&
              item.name !== "飲食店"
            ) {
              return item;
            }
            if (item.catLrgClassCd === "119" && item.name !== "お問合せ") {
              return item;
            }
            if (
              item.catLrgClassCd !== "119" &&
              item.catLrgClassCd !== "113" &&
              item.catLrgClassCd !== "011"
            ) {
              return item;
            }
          }
        });
        return uniqBy(listFilter, "catClassCd");
      }
      return [];
    },
    /** @returns {Array<Categories>} */
    smallCategoryList() {
      if (this.categories.length) {
        const listFilter = filter(
          this.categories,
          (item) =>
            item.level === 3 &&
            item.catLrgClassCd === this.form.catLrgClassCd &&
            item.catMidClassCd === this.form.catMidClassCd
        );
        return uniqBy(listFilter, "catClassCd");
      }
      return [];
    },
    /** @returns {Array<Categories>} */
    categoryList() {
      if (this.categories.length) {
        const listFilter = filter(this.categories, (item) => {
          if (
            !this.lifeGenreTags.find((o) => o.catClassCd === item.catClassCd)
          ) {
            if (
              item.level === 3 &&
              item.catLrgClassCd === "113" &&
              item.catMidClassCd === "201"
            ) {
              return item;
            }
          }
        });
        return uniqBy(listFilter, "catClassCd");
      }
      return [];
    }
  },
  methods: {
    async getMidCodesArea() {
      const res = await getLargeCodesArea();
      if (res) {
        this.areaMidClasses = res || [];
      }
    },
    async getSmlCodesArea(index) {
      const data = this.areaMidClasses[index - 1];
      const res = await getCodesArea({
        areaLrgClassCd: data.areaLrgClassCd,
        areaMidClassCd: data.areaMidClassCd
      });
      if (res) {
        this.form.areaLrgClassCd = data.areaLrgClassCd;
        this.form.areaMidClassCd = data.areaMidClassCd;
        this.areaSmlClasses =
          res?.areaLrgClasses?.[0]?.areaMidClasses?.[0]?.areaSmlClasses || [];
      }
    },
    async getDtlCodesArea(index) {
      const data = this.areaSmlClasses[index - 1];
      const res = await getCodesArea({
        areaLrgClassCd: this.form.areaLrgClassCd,
        areaMidClassCd: this.form.areaMidClassCd,
        areaSmlClassCd: data.areaSmlClassCd
      })
      if (res) {
        this.areaDtlClasses =
          res?.areaLrgClasses?.[0]?.areaMidClasses?.[0]?.areaSmlClasses?.[0]
            ?.areaDtlClasses || [];
      }
    },
    lifeNavChange(num) {
      this.form.lifeIsActive = num;
      this.form.catLrgClassCd = "";
      this.form.catMidClassCd = "";
      this.form.catSmlClassCd = "";
      this.form.areaLrgClassCd = "";
      this.form.areaMidClassCd = "";
      this.form.areaSmlClassCd = "";
      this.form.areaDtlClassCd = "";
      this.form.keywordError = "";
      this.lifeGenreTags = [];
    },
    lifeGenreChanged(e) {
      if (!e.target.value) { return }

      const category = e.target.value.split(",");
      this.lifeGenreTags.push({
        catClassCd: category[0],
        name: category[1],
        level: category[2]
      });
    },
    deleteLifeGenreTags(index) {
      this.$delete(this.lifeGenreTags, index);
    },
    input(args) {
      this.form.keyword = args;
    },
    onSearch(currentId) {
      this.form.keywordError = "";
      this.form.numberError = "";
      if (this.form.lifeIsActive === 0) {
        if (this.form.pointFrom < 0 || this.form.pointTo < 0) {
          this.form.numberError = "マイナス値は入力できません";
          return;
        }
        if (this.form.pointFrom > this.form.pointTo) {
          this.form.numberError =
            "最小 < 最大 になるようにポイント数を入力して下さい";
          return;
        }
        if (
          !this.form.keyword &&
          !this.form.catLrgClassCd &&
          !this.form.catMidClassCd &&
          !this.form.catSmlClassCd
        ) {
          this.form.keywordError =
            "カテゴリを選択するかキーワードを入力してください。";
          return;
        }
      }
      if (this.form.lifeIsActive === 1) {
        if (this.form.pointFrom < 0 || this.form.pointTo < 0) {
          this.form.numberError = "マイナス値は入力できません";
          return;
        }
        if (this.form.pointFrom > this.form.pointTo) {
          this.form.numberError =
            "最小 < 最大 になるようにポイント数を入力して下さい";
          return;
        }
        if (
          !this.form.keyword &&
          !this.form.catLrgClassCd &&
          !this.form.catMidClassCd &&
          !this.form.catSmlClassCd
        ) {
          this.form.keywordError =
            "カテゴリを選択するかキーワードを入力してください。";
          return;
        }
      }
      const params = new URLSearchParams(this.getQueryString());
      const url =
        process.env.VUE_APP_LIFE_DOMAIN + "/product/list-life?" + params;
      window.open(url, "_self");
    },
    getQueryString() {
      const query = {};
      switch (this.form.lifeIsActive) {
        case 1:
          query.type = 1;
          if (this.form.catLrgClassCd) {
            query.catLrgClassCd = this.form.catLrgClassCd;
          }
          if (this.form.catMidClassCd) {
            query.catMidClassCd = this.form.catMidClassCd;
          }
          if (this.form.catSmlClassCd) {
            query.catSmlClassCd = this.form.catSmlClassCd;
          }
          break;
        case 2:
          query.type = 2;
          if (this.form.areaMidClassCd) {
            query.areaMidClassCd = this.form.areaMidClassCd;
          }
          if (this.form.areaSmlClassCd) {
            query.areaSmlClassCd = this.form.areaSmlClassCd;
          }
          if (this.form.areaDtlClassCd) {
            query.areaDtlClassCd = this.form.areaDtlClassCd;
          }
          if (this.lifeGenreTags.length) {
            const tags = this.lifeGenreTags.map((x) => x.catClassCd);
            query.lifeGenreTags = tags;
          }
          break;
        default:
          break;
      }
      if (this.form.keyword) {
        query.keyword = this.form.keyword;
      }
      return query;
    },
    onChangeMidArea(event) {
      if (event.target.value === "") {
        this.form.areaMidClassCd = "";
        this.form.areaSmlClassCd = "";
        this.form.areaDtlClassCd = "";
        this.areaSmlClasses = [];
        this.areaDtlClasses = [];
      } else if (event.target.value !== "") {
        this.form.areaMidClassCd = event.target.value;
        this.form.areaSmlClassCd = "";
        this.form.areaDtlClassCd = "";
        this.areaSmlClasses = [];
        this.areaDtlClasses = [];
        this.getSmlCodesArea(event.target.selectedIndex);
      }
    },
    onChangeSmlArea(event) {
      if (event.target.value === "") {
        this.form.areaSmlClassCd = "";
        this.form.areaDtlClassCd = "";
        this.areaDtlClasses = [];
      } else if (event.target.value !== "") {
        this.form.areaSmlClassCd = event.target.value;
        this.form.areaDtlClassCd = "";
        this.areaDtlClasses = [];
        this.getDtlCodesArea(event.target.selectedIndex);
      }
    },
    onChangeLargeCat(event) {
      if (event.target.value === "") {
        this.form.catLrgClassCd = "";
        this.form.catMidClassCd = "";
        this.form.catSmlClassCd = "";
      } else if (event.target.value !== "") {
        this.form.catLrgClassCd = event.target.value;
        this.form.catMidClassCd = "";
        this.form.catSmlClassCd = "";
      }
    },
    onChangeMidCat(event) {
      if (event.target.value === "") {
        this.form.catMidClassCd = "";
        this.form.catSmlClassCd = "";
      } else if (event.target.value !== "") {
        this.form.catMidClassCd = event.target.value;
        this.form.catSmlClassCd = "";
      }
    },
    onChangeSearch(clickedId) {
      this.switchTab(clickedId);
      this.form.keywordError = "";
      this.form.numberError = "";
      this.form.pointFrom = "";
      this.form.pointTo = "";
      if (clickedId === 0) {
        window.history.replaceState(null, "", "?selected=life");
        this.form.lifeIsActive = 1;
      }
      if (clickedId === 1) {
        window.history.replaceState(null, "", "?selected=goods");
        this.form.lifeIsActive = 2;
      }
      // this.middleCategoryList();
    }
  }
};
</script>
<style scoped lang="scss">
section {
  display: block;
}

.p-toppage__cassette {
  margin: 2rem 0 1rem;

  .p-toppage__cassette__wrap {
    display: flex;
    padding-bottom: 0.5rem;
    width: 90%;
    margin: 0 auto;

    .p-toppage__cassette__title {
      width: calc(91.6% / 2);
      padding-bottom: 0.5rem;
      cursor: pointer;
      font-size: 16px;
      font-weight: bold;
      text-align: center;

      img {
        width: 0.75rem;
        height: auto;
        display: inline-block;
        margin-left: 0.5rem;
      }
    }

    .p-toppage__cassette__title.is-active {
      color: #da291c;
      border-bottom: 3px solid #da291c;
    }

    .spacer {
      width: 0.2%;
      background-color: #dcdee0;
      margin: 0 2%;
      height: 1.5rem;
      border-radius: 4px;
    }
  }
}

.p-toppage__search {
  margin-bottom: 3rem;

  .p-toppage__search__wrap {
    .p-toppage__search__main {
      margin-bottom: 2rem;

      .p-toppage__search__main__nav {
        overflow: visible;

        .c-card__inner {
          padding: 2rem;

          .p-toppage__search__main__row {
            .p-toppage__search__main__areaSelector {
              display: flex;
              flex-wrap: wrap;

              .c-select {
                position: relative;
                width: calc(100% / 3 - 0.5rem);
                margin-right: 0.5rem;

                .c-select__control {
                  cursor: pointer;
                  font-size: 1rem;
                  line-height: 1.25;
                  background: #fff;
                  border: 1px solid #cacccf;
                  border-radius: 4px;
                  padding: 0.375rem 0.5rem;
                  width: 100%;
                  height: 2.5rem;
                }

                select {
                  appearance: none;
                }
              }

              .c-select:after {
                content: "";
                position: absolute;
                right: 10px;
                top: 15px;
                width: 10px;
                height: 10px;
                border-top: 2px solid #ccc;
                border-left: 2px solid #ccc;
                transform: translateY(-50%) rotate(-135deg);
                font-size: 20px;
                pointer-events: none;
              }
            }

            .p-toppage__search__main__keyword {
              padding-right: 1.5rem;
              width: 88%;
              display: inline-block;
            }

            .p-toppage__search__main__point {
              display: flex;
              align-items: center;

              .p-toppage__search__main__point__content {
                display: flex;
                align-items: center;
                .p-toppage__search__main__point__content__input {
                  display: flex;
                  margin: 10px;
                  align-items: center;

                  input {
                    border: 1px solid gray;
                    border-radius: 3px;
                    padding: 10px 15px;
                  }
                  p {
                    margin-left: 15px;
                  }
                }

                .p-toppage__search__main__point__content__space {
                  font-size: 20px;
                  font-weight: 700;
                  padding: 0px 30px;
                }
              }
            }
            .p-toppage__search__main__point:last-child {
              display: block;
              .p-toppage__search__main__point__content__input--error {
                color: #cc0621;
              }
            }
          }

          .p-toppage__search__main__row + .p-toppage__search__main__row {
            margin-top: 1rem;
          }
        }
      }

      .c-card {
        background: #fff;
        box-shadow: 0 1px 0.5rem rgb(31 32 33 / 8%);
        border-radius: 0.5rem;
        line-height: 1.8;
      }

      .c-card > :last-child {
        margin-bottom: 0;
      }
    }
  }
}

@media only screen and (max-width: 640px) {
  .p-toppage__cassette__wrap {
    gap: 10px;
  }
  .sp_tabTitle {
    font-size: 13px;
    white-space: nowrap;
    &.is-active,
    &.is-active > a {
      color: #dd0000;
    }
  }
}
</style>
